// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__Nbew9","faq-list":"FAQ_faq-list__VkAUz","faq-item":"FAQ_faq-item__V7tC3"};